<template>
	<div class="slidePage4">
        <div class="title">
            <img src="@/assets/heart_left.png" alt="">
            <span>成果展示</span>
            <img src="@/assets/heart_right.png" alt="">
        </div>
        <el-carousel class="slidePageCarousel" :interval="4000" :autoplay="false" type="card" height="90%">
            <el-carousel-item >
                <div class="item">
                    <img class="img" src="@/assets/page4-1.png" alt="" />
                </div>
                <span class="item-title">2020年中新信息通信联合创新发展资金支持项目</span>
            </el-carousel-item>
            <el-carousel-item >
                <div class="item">
                    <img class="img" src="@/assets/page4-2.png" alt="" />
                </div>
                <span class="item-title">入选重庆市移动物联网应用优秀案例</span>
            </el-carousel-item>
            <el-carousel-item >
                <div class="item">
                    <img class="img" src="@/assets/page4-3.png" alt="" />
                </div>
                <span class="item-title">《重庆日报》  2020年11月04日 </span>
            </el-carousel-item>
            <el-carousel-item >
                <div class="item">
                    <img class="img" src="@/assets/page4-4.png" alt="" />
                </div>
                <span class="item-title">《重庆新闻联播》 2021年1月10日</span>
            </el-carousel-item>
            <el-carousel-item >
                <div class="item">
                    <img class="img" src="@/assets/page4-5.png" alt="" />
                </div>
                <span class="item-title">《重庆市渝北区人民政府》2021年03月24日 仙桃街道建设全市首个“三位一体”智慧居家养老服务体系 </span>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
	name: 'SlidePage4',
}
</script>

<style lang="scss" scoped>
.slidePage4 {
	width: 100%;
	height: 100%;
	background: url('../assets/slide4_bg.png');
	background-size: 100% 100%;
    background-position: center;
    background-attachment: fixed;
    overflow: hidden;
    ::v-deep .el-carousel__indicators--outside button{
        width: 14px;
        height: 14px;
        background: #fff;
        opacity: 1;
        border-radius: 50%;
    }
    ::v-deep .el-carousel__indicator.is-active button{
        background: #8CFF94;
    }
    ::v-deep .el-carousel__mask{
        background-color: transparent
    }
    .title{
        margin: 4% 0 3% 0;
        display: flex;
        justify-content: center;
        align-items: center;
        span{
            font-size: 40px;
            font-weight: 500;
            color: #FFFFFF;
            margin: 0 20px;
        }
    }
    .slidePageCarousel{
        height: 60%;
        width: 60%;
        margin: 0 auto;
        margin-top: 50px;
        .item{
            width: 100%;
            height: 85%;
            background: #fff;
            position: relative;
            box-shadow: 4px 10px 12px 0px rgba(41, 164, 88, 0.19);
            margin-bottom: 34px;
            border-radius: 4px;
            img{
                position: absolute;
                top:50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .item-title{
            font-size: 18px;
            font-weight: 500;
            color: #fff;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            display: inline-block;
        }
    }
}
</style>
